// src/app/app.config.ts
// VERSION: v4.2.1 - added GlobalErrorHandler for chunk-load resilience
// DATE: 2026-04-19
import { ApplicationConfig, ErrorHandler } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideZoneChangeDetection } from '@angular/core';
import { routes } from './app.routes';
import { AuthErrorInterceptor } from './interceptors/auth-error.interceptor';
import { GlobalErrorHandler } from './services/global-error-handler';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    // ── Sprung an eine Stelle in der Seite — Item #95, 2026-08-19 ───────────
    //
    // 🔴 OHNE `anchorScrolling` PASSIERT BEI EINEM FRAGMENT SCHLICHT NICHTS.
    //   Angular ignoriert `#abschnitt` in der Adresse standardmäßig. Das Brett
    //   verweist seit dem 19.08. auf `…/item/95#post-82` — ohne diese Zeile
    //   landet jeder Klick oben auf der Seite, und niemand sieht, woran es liegt.
    //
    // 🟡 ES GENÜGT ALLEIN NICHT: Angular scrollt, sobald die Route steht — die
    //   Daten kommen aber erst danach per HTTP, und das Ziel existiert dann noch
    //   nicht. Deshalb zusätzlich shared/scroll-to-fragment.ts, das nach dem
    //   Laden noch einmal springt. Beides zusammen, keins allein.
    provideRouter(routes, withInMemoryScrolling({
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled',
    })),
    provideHttpClient(),

    // HTTP interceptor: fängt Auth-Fehler (401/403) ab
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthErrorInterceptor,
      multi: true
    },

    // Globaler Error Handler: fängt Chunk-Load-Fehler ab (404 nach Deployment)
    // und triggert automatisch einen Reload statt schwarzer Seite
    { provide: ErrorHandler, useClass: GlobalErrorHandler }
  ]
};
